<div class="p8-settings-page__container" fxLayout="column">
  <div class="p8-settings-page__content-container" fxFlex="grow">
    <ng-content></ng-content>
  </div>
  <ng-content select="p8-layout-settings-footer"></ng-content>
</div>
